(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pnm-brand-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.pnmBrandHeroReady) return;
  window.pnmBrandHeroReady = true;
  const bikeFilterKeys = ['gff_705339', 'gff_705340', 'gff_705341', 'gff_705342'];
  const selectionKey = 'pnm_selected_bike_v1';
  const decorateLinks = () => {
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (!previewTheme) return;
    document.querySelectorAll('[data-pnm-brand-link]').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (target.origin !== location.origin) return;
      target.searchParams.set('preview_theme_id', previewTheme);
      link.href = target.pathname + target.search;
    });
  };
  const browseBrand = event => {
    const link = event.target.closest('[data-pnm-brand-link]');
    if (!link || event.button > 1 || event.defaultPrevented) return;
    const target = new URL(link.href, location.origin);
    if (target.origin !== location.origin) return;
    [...bikeFilterKeys, selectionKey].forEach(key => {
      try { localStorage.removeItem(key); } catch (error) {}
    });
    window.defaultFilterParams = {};
    const current = new URL(location.href);
    [...bikeFilterKeys, 'gf_852962', 'gf_select-your-model'].forEach(key => current.searchParams.delete(key));
    if (current.href !== location.href) history.replaceState(history.state, '', current.href);
    window.dispatchEvent(new StorageEvent('storage', { key: selectionKey, newValue: null }));
  };
  document.addEventListener('click', browseBrand, true);
  document.addEventListener('auxclick', browseBrand, true);
  document.addEventListener('shopify:section:load', decorateLinks);
  window.addEventListener('pageshow', decorateLinks);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateLinks, { once: true });
  else decorateLinks();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-contact-bike-prefill"]) return;
  try {
    
(() => {
  const fillSelectedBike = () => {
    const form = document.getElementById('ContactForm');
    if (!form || form.dataset.pnmBikePrefillReady) return;
    form.dataset.pnmBikePrefillReady = 'true';
    const modelField = form.querySelector('[name="contact[motormodel]"]');
    const yearField = form.querySelector('[name="contact[motoryear]"]');
    if (!modelField || !yearField || modelField.value.trim() || yearField.value.trim()) return;
    if (document.activeElement === modelField || document.activeElement === yearField) return;
    const keys = ['gff_705339', 'gff_705341', 'gff_705342'];
    const params = new URLSearchParams(window.location.search);
    let values;
    if (keys.some((key) => params.has(key))) {
      values = keys.map((key) => params.get(key) || '');
    } else {
      try {
        values = keys.map((key) => window.localStorage.getItem(key) || '');
      } catch (error) {
        return;
      }
    }
    const [brand, model, year] = values.map((value) => value.trim());
    if (!/^(Honda|Yamaha|Kawasaki|Suzuki)( ATV)?$/i.test(brand)) return;
    if (!model || model.length > 80 || /[\x00-\x1f<>|,]/.test(model)) return;
    modelField.value = model.toLowerCase().startsWith(brand.toLowerCase() + ' ') ? model : brand + ' ' + model;
    if (/^\d{4}$/.test(year)) yearField.value = year;
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillSelectedBike, { once: true });
  } else {
    fillSelectedBike();
  }
  document.addEventListener('shopify:section:load', fillSelectedBike);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-home-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new WeakMap();
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLElement) || !item.matches('.pnm-home-faq__item')) return;
    const panel = item.querySelector('.pnm-home-faq__reveal');
    if (!panel) return;
    const previous = active.get(panel);
    if (previous) {
      previous.cancel();
      active.delete(panel);
    }
    if (!item.open || motion.matches || typeof panel.animate !== 'function') return;
    const height = panel.getBoundingClientRect().height;
    if (height <= 0) return;
    const animation = panel.animate([
      { height: '0px', opacity: 0, overflow: 'hidden' },
      { height: height + 'px', opacity: 1, overflow: 'hidden' }
    ], { duration: 190, easing: 'cubic-bezier(.2,.7,.2,1)' });
    active.set(panel, animation);
    animation.onfinish = () => active.delete(panel);
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
